<template>
  <nav class="navi">
    <div class="inner">
      <span class="user-link" @click="openLogin" v-if="!$store.state.is_logged"
        >Login</span
      >
      <a class="user-link" v-else href="/my-account">Account</a>
      <ul v-if="navi && navi.length !== 0">
        <li
          v-for="(item, index) in navi"
          :key="item.id"
          class="item"
          :class="['item-' + (index + 1)]"
        >
          <Link :link="item">
            {{item.title}}
          </Link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { EventBus } from "@/events/bus.js";
import Link from '@/components/ui/Link.vue';

export default {
  name: "site-navi",

  components: {
    Link,
  },

  data() {
    return {
      navi: []
    };
  },

  methods: {
    openLogin() {
      EventBus.$emit("login.open");
    }
  },

  mounted() {
    this.$ajax.get("/menus/153").then(res => {
      res.data.items.forEach(function(item) {
        item.url = item.url.includes(window.globals.home_url) ? item.url.replace(window.globals.home_url, "") : item.url;
      });

      this.navi = res.data.items;
    });
  }
};
</script>

<style lang="scss">
.navi {
  display: flex;
  position: sticky;
  left: 0;
  width: 100%;
  justify-content: center;
  z-index: 999;
  top: 0;
  background: white;
  transform: translate(0%, 0%);
  transition: transform 0.2s ease;

  ul {
    display: flex;
    padding: 0 var(--padding);
    margin: 0 auto;
    justify-content: center;
  }

  li {
    padding: 0 var(--padding);
    position: relative;
    z-index: 339;
    text-transform: uppercase;
  }

  .inner {
    position: relative;
    margin: var(--padding) 0;

    & > .user-link {
      position: absolute;
      left: 0;
      top: 0;
      text-transform: uppercase;
      z-index: 3;
      cursor: pointer;
      display: none;

      @at-root {
        body.page-product &,
        body.page-product-category &,
        body.page-shop & {
          display: nonenone;
        }
      }
    }
  }

  a,
  a:visited,
  a:active {
    color: black;
  }

  a.router-link-active,
  a.router-link-exact-active {
    color: var(--gray);
  }
}

body.is-sticky .navi {
  transform: translate(0%, -100%);
}

body.is-sticky.show-header .navi {
  transform: translate(0%, 0%);
}

body.page-single-festival,
body.type-landing-page {
  .navi {
    background: transparent;
  }
}

body.page-home,
body.page-ideas,
body.page-stories,
body.page-objects {
  .navi {
    background: black;

    span,
    a,
    a:visited,
    a:active {
      color: white;
    }
  }
}

body.page-home {
  .navi {
    background: transparent;
  }
}

body.page-whats-on {
  .navi {
    background: var(--green-2);
  }
}

body.page-single-festival .navi li.item-1 a,
body.type-landing-page .navi li.item-1 a,
body.page-single-exhibition .navi li.item-1 a,
body.page-single-event .navi li.item-1 a,
body.page-product-category .navi li.item-3 a,
body.page-product .navi li.item-3 a {
  color: var(--gray);
}

@media only screen and (max-width: 767px) {
  .navi {
    display: none;
  }

  body.page-home {
    .navi {
      display: none;
    }
  }
  // .navi {
  //     li, ul {
  //         padding: 0 var(--padding-50);
  //     }
  //     .user-link {
  //         display: none;
  //     }
  // }
}
</style>
